import { ChangeEvent, FC, KeyboardEvent, useState } from 'react';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Stack, Typography } from '@mui/material';
import { SearchTextField } from '~/components';
import { TableSearchChangeCallback } from '~/pages/ProjectDetailsPage/tabs/WorkbenchTab/types';
import useTableFilters from './context/useTableFilters';

interface TablePanelContentProps {
  onSearchChange: TableSearchChangeCallback;
  hideFooter?: boolean;
  searchPlaceholder?: string;
  searchWidth?: string;
  initialSearchText?: string;
}

const TablePanel: FC<TablePanelContentProps> = ({
  onSearchChange,
  hideFooter,
  searchPlaceholder,
  searchWidth,
  initialSearchText,
}) => {
  const [searchText, setSearchText] = useState(initialSearchText || '');
  const { filterOptions, openFilters, open } = useTableFilters();

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearchChange(searchText);
    }
  };

  return (
    <Stack spacing={2} pb={hideFooter ? 2 : 0}>
      <Stack direction="row" alignItems="center" spacing={2}>
        {filterOptions && (
          <>
            <CustomButton buttonType="filter" onClick={openFilters} sx={{ height: 35 }}>
              <Typography variant="buttonTextStandard">{open ? 'Hide Filters' : 'Filters'}</Typography>
            </CustomButton>
          </>
        )}
        <SearchTextField
          size="small"
          onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value)}
          onClear={() => {
            setSearchText('');
            onSearchChange('');
          }}
          onKeyDown={handleKeyDown}
          value={searchText}
          placeholder={searchPlaceholder || 'Search'}
          sx={{ width: searchWidth }}
        />
      </Stack>
    </Stack>
  );
};

export default TablePanel;
